import { render, staticRenderFns } from "./editStorebrandSupplier.vue?vue&type=template&id=f5bb3ce6&scoped=true"
import script from "./editStorebrandSupplier.vue?vue&type=script&lang=js"
export * from "./editStorebrandSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bb3ce6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5bb3ce6')) {
      api.createRecord('f5bb3ce6', component.options)
    } else {
      api.reload('f5bb3ce6', component.options)
    }
    module.hot.accept("./editStorebrandSupplier.vue?vue&type=template&id=f5bb3ce6&scoped=true", function () {
      api.rerender('f5bb3ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/storeBrand/editStorebrandSupplier.vue"
export default component.exports